var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttackSurfaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.224121,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#3F46AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3343_8800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.22412,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3343_8800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17.7241C15.85 17.7241 16.1792 17.6783 16.4875 17.5866C16.7958 17.495 17.1 17.3575 17.4 17.1741L18.925 18.7491C19.0583 18.8991 19.2292 18.97 19.4375 18.9616C19.6458 18.9533 19.825 18.8825 19.975 18.7491C20.125 18.5991 20.2042 18.42 20.2125 18.2116C20.2208 18.0033 20.15 17.8241 20 17.6741L18.45 16.1241C18.6333 15.8408 18.7708 15.5408 18.8625 15.2241C18.9542 14.9075 19 14.5741 19 14.2241C19 13.2408 18.6542 12.4116 17.9625 11.7366C17.2708 11.0616 16.45 10.7241 15.5 10.7241C14.55 10.7241 13.7292 11.0616 13.0375 11.7366C12.3458 12.4116 12 13.2408 12 14.2241C12 15.2075 12.3458 16.0366 13.0375 16.7116C13.7292 17.3866 14.55 17.7241 15.5 17.7241ZM15.5 16.2241C14.95 16.2241 14.4792 16.0283 14.0875 15.6366C13.6958 15.245 13.5 14.7741 13.5 14.2241C13.5 13.6741 13.6958 13.2033 14.0875 12.8116C14.4792 12.42 14.95 12.2241 15.5 12.2241C16.0333 12.2241 16.5 12.42 16.9 12.8116C17.3 13.2033 17.5 13.6741 17.5 14.2241C17.5 14.7741 17.3042 15.245 16.9125 15.6366C16.5208 16.0283 16.05 16.2241 15.5 16.2241ZM6 25.2241C5.71667 25.2241 5.47917 25.1283 5.2875 24.9366C5.09583 24.745 5 24.5075 5 24.2241C5 23.9408 5.09583 23.7033 5.2875 23.5116C5.47917 23.32 5.71667 23.2241 6 23.2241H26C26.2833 23.2241 26.5208 23.32 26.7125 23.5116C26.9042 23.7033 27 23.9408 27 24.2241C27 24.5075 26.9042 24.745 26.7125 24.9366C26.5208 25.1283 26.2833 25.2241 26 25.2241H6ZM8 22.2241C7.45 22.2241 6.97917 22.0283 6.5875 21.6366C6.19583 21.245 6 20.7741 6 20.2241V9.22412C6 8.67412 6.19583 8.20329 6.5875 7.81162C6.97917 7.41995 7.45 7.22412 8 7.22412H24C24.55 7.22412 25.0208 7.41995 25.4125 7.81162C25.8042 8.20329 26 8.67412 26 9.22412V20.2241C26 20.7741 25.8042 21.245 25.4125 21.6366C25.0208 22.0283 24.55 22.2241 24 22.2241H8ZM8 20.2241H24V9.22412H8V20.2241Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttackSurfaceIcon);
export default __webpack_public_path__ + "static/media/Attack_surface_icon.d6ebdaf7316ccca9cc2203fefd5a5dd1.svg";
export { ForwardRef as ReactComponent };